module.exports = __webpack_public_path__ + "static/media/bat1.7c17d522.png";